function TriggerFormController(CommonService, $uibModal) {
  const ctrl = this;
  const swap = CommonService.swap;

  ctrl.$onInit = () => {
    ctrl.collectionTooltip = "Inspect collections and commands by clicking a row";
  };

  ctrl.$onChanges = changes => {
    if (changes.condition) {
      ctrl.condition = Object.assign({}, ctrl.condition);
    }
  };

  ctrl.openTriggerModal = () => {
    let modalInstance = $uibModal.open({
      component: 'triggerModal',
      backdrop: 'static',
      resolve: {
        triggers: function () {
          return ctrl.triggers;
        },
      },
    });

    modalInstance.result.then(
      selectedTrigger => {
        // User pressed 'Yes' in the modal.
        ctrl.condition.triggers.push(selectedTrigger);
        ctrl.onSelect({
          $event: {
            selectedTriggers: ctrl.condition.triggers,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.removeTrigger = index => {
    ctrl.condition.triggers.splice(index, 1);
    ctrl.onSelect({
      $event: {
        selectedTriggers: ctrl.condition.triggers,
      },
    });
  };

  ctrl.inspectTrigger = trigger => {
    let modalInstance = $uibModal.open({
      component: 'inspectModal',
      backdrop: 'static',
      resolve: {
        trigger: function () {
          return trigger;
        },
      },
    });

    modalInstance.result.then(
      () => {
      },
      () => {
        // User pressed 'Close' in the modal, do nothing.
      }
    );
  };

  ctrl.move = (slot1, slot2) => {
    ctrl.condition.triggers = swap(angular.copy(ctrl.condition.triggers), slot1, slot2);
    ctrl.onSelect({
      $event: {
        selectedTriggers: ctrl.condition.triggers,
      },
    });
  };

  ctrl.openCommandModal = () => {
    let modalInstance = $uibModal.open({
      component: 'commandModal',
      backdrop: 'static',
      resolve: {
        triggers: function () {
          return ctrl.triggers;
        },
        conditions: function () {
          return ctrl.conditions;
        },
        condition: function () {
          return ctrl.condition;
        },
        variables: function () {
          return ctrl.variables;
        },
        environmentVariableObjects: function () {
          return ctrl.environmentVariableObjects;
        }
      },
    });

    modalInstance.result.then(
      selectedTrigger => {
        // User pressed 'Yes' in the modal.
        ctrl.condition.triggers.push(selectedTrigger);
        ctrl.onSelect({
          $event: {
            selectedTriggers: ctrl.condition.triggers,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('pis-tool.module')
  .controller('TriggerFormController', TriggerFormController);
